module.exports = __webpack_public_path__ + "img/RX-Arcos-7-zoom.71acdf10.png";